function stableStringify(value) {
  return JSON.stringify(value, (_key, nestedValue) => {
    if (!nestedValue || Array.isArray(nestedValue) || typeof nestedValue !== 'object') return nestedValue;

    return Object.keys(nestedValue)
      .sort()
      .reduce((sortedValue, key) => {
        sortedValue[key] = nestedValue[key];
        return sortedValue;
      }, {});
  });
}

function compareSnapshots(left, right) {
  const leftId = String(left?.id ?? '');
  const rightId = String(right?.id ?? '');
  if (leftId < rightId) return -1;
  if (leftId > rightId) return 1;
  const leftSnapshot = String(stableStringify(left));
  const rightSnapshot = String(stableStringify(right));
  if (leftSnapshot < rightSnapshot) return -1;
  if (leftSnapshot > rightSnapshot) return 1;
  return 0;
}

function fingerprintSnapshots(snapshots) {
  return stableStringify(Array.from(snapshots).sort(compareSnapshots));
}

function fingerprintSnapshotMap(snapshotMap) {
  return fingerprintSnapshots(snapshotMap.values());
}

export function stabilizeEntitySnapshots(previous, next) {
  if (!previous || !next) return next;

  const profileMatches = fingerprintSnapshotMap(previous.profile) === fingerprintSnapshotMap(next.profile);
  const channelMatches = fingerprintSnapshotMap(previous.channel) === fingerprintSnapshotMap(next.channel);
  const emojiMatches = fingerprintSnapshots(previous.emojiList) === fingerprintSnapshots(next.emojiList);

  if (previous.workspace_id === next.workspace_id && profileMatches && channelMatches && emojiMatches) return previous;

  return {
    ...next,
    profile: profileMatches ? previous.profile : next.profile,
    channel: channelMatches ? previous.channel : next.channel,
    emoji: emojiMatches ? previous.emoji : next.emoji,
    emojiByShortcode: emojiMatches ? previous.emojiByShortcode : next.emojiByShortcode,
    emojiList: emojiMatches ? previous.emojiList : next.emojiList,
  };
}
